import { ConfiguredCarCatalogImage, Maybe, TypedConfiguredCarCatalogImages } from '~/graphql/__generated__/graphql';
import { ExtendedCatalogImage } from '~/graphql/hooks/use-images';

export default function GetUrlFromImageSet(
	imageSets: TypedConfiguredCarCatalogImages[] | undefined | null,
	type: string,
) {
	if (!imageSets || imageSets.length < 1) return;
	return imageSets?.find((a) => a.type === type)?.images[0]?.url;
}

export function GetUrlArrayFromImageSet(imageSets: TypedConfiguredCarCatalogImages[] | undefined | null, type: string) {
	if (!imageSets || imageSets.length < 1) return;
	return (
		imageSets
			?.find((a) => a.type === type)
			// sometimes we also receive mp4 files, so we filter them out
			?.images?.filter((a) => a?.mimeType?.includes('image'))
			?.map((b) => b?.url)
	);
}

export function GetMediaFromImageSet(imageSets: TypedConfiguredCarCatalogImages[] | undefined | null, type: string) {
	if (!imageSets || imageSets.length < 1) return;
	return imageSets?.find((a) => a.type === type)?.images[0];
}

export function GetMediaArrayFromImageSet(
	imageSets: TypedConfiguredCarCatalogImages[] | undefined | null,
	type: string,
) {
	if (!imageSets || imageSets.length < 1) return;
	return imageSets?.find((a) => a.type === type)?.images?.map((b) => b);
}

export function GetModifiedItemWithNameFromMedia(
	media: Maybe<ConfiguredCarCatalogImage> | undefined,
	itemName: string,
) {
	if (!media) return undefined;
	const modifiedMedia: ExtendedCatalogImage = {
		...media,
		itemName,
	} as ExtendedCatalogImage;

	return modifiedMedia;
}

export function GetModifiedItemsWithItemNameFromMedia(
	media: Maybe<ConfiguredCarCatalogImage>[] | undefined,
	itemName: string,
) {
	if (!media || media.length < 1) return undefined;
	const modifiedMedia: ExtendedCatalogImage[] = media.map((entry) => {
		return {
			...entry,
			itemName,
		} as ExtendedCatalogImage;
	});

	return modifiedMedia;
}
